export class CodigoRespuesta {
    public static Exito = 1;
    public static Advertencia = 2;
    public static Error = 3;
}